module.exports = __webpack_public_path__ + "fonts/CCBackBeatLight.9febfb4.ttf";